import { capitalize } from 'lodash';
import { useEffect, useState } from 'react';

import { doFetch, RemoteDataError } from '../../api/queries';
import { logException } from '../../common/sentry';
import { getCookie, sleep } from '../../common/utils';
import { t } from '../../localization/LocaleContext';

export function translateError(error: string) {
  switch (error) {
    case 'invalid_token':
      return t('general_form_error_invalid_token');
    case 'token_expired':
      return t('general_form_error_token_expired');
    case 'invitation_already_accepted':
      return t('general_form_error_invitation_already_accepted');
    case 'invalid_email':
      return t('general_form_error_invalid_email');
    case 'password_too_weak':
      return t('general_form_error_password_too_weak');
    case 'email_in_use':
      return t('general_form_error_email_in_use');
    case 'invalid_credentials':
      return t('general_form_error_invalid_credentials');
    default:
      logException(new Error(`Unknown error message: '${error}'`));
      return capitalize(error.replaceAll('_', ' '));
  }
}

export function useXsrf() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<RemoteDataError | undefined>(undefined);
  const [xsrfToken, setXsrfToken] = useState<string>();
  useEffect(() => {
    doFetch({ method: 'GET', uri: '/api/xsrf', converter: (v) => v })
      .then(() => sleep(100))
      .then(() => {
        const token = getCookie('_xsrf');
        if (!token) {
          throw new Error('No xsrf cookie found');
        }
        setXsrfToken(token);
        setLoading(false);
        return undefined;
      })
      .catch((xsrf_error: RemoteDataError) => {
        setLoading(false);
        logException(xsrf_error);
        setError(xsrf_error);
      });
  }, []);

  return {
    loading,
    error,
    xsrfToken,
  };
}
